/**
 * Adaugare in cos din pagina de cos: butonul de la posterul recomandat si butoanele
 * din randul "cele mai vandute". Ascultarea e delegata pe document pentru ca sectiunea
 * de cos se re-randeaza singura dupa fiecare schimbare de cantitate.
 */
(function () {
  'use strict';

  var ocupat = false;

  function urlAdaugare() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    return '/cart/add.js';
  }

  function eroare(buton, text) {
    var el = buton.parentNode.querySelector('[data-br-eroare]');
    if (!el) {
      el = document.createElement('span');
      el.className = 'br-cos-eroare';
      el.setAttribute('data-br-eroare', '');
      buton.parentNode.appendChild(el);
    }
    el.textContent = text;
  }

  document.addEventListener('click', function (ev) {
    var buton = ev.target.closest ? ev.target.closest('[data-br-adauga]') : null;
    if (!buton) return;

    ev.preventDefault();
    if (ocupat || buton.disabled) return;

    var id = buton.getAttribute('data-variant-id');
    if (!id) return;

    ocupat = true;
    var textInitial = buton.textContent;
    buton.disabled = true;
    buton.classList.add('br-cos-incarca');
    buton.textContent = 'Se adaugă...';

    fetch(urlAdaugare(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { ok: r.ok, date: d };
        });
      })
      .then(function (raspuns) {
        if (!raspuns.ok) {
          throw new Error((raspuns.date && raspuns.date.description) || 'Nu am putut adăuga produsul.');
        }
        window.location.reload();
      })
      .catch(function (e) {
        ocupat = false;
        buton.disabled = false;
        buton.classList.remove('br-cos-incarca');
        buton.textContent = textInitial;
        eroare(buton, e.message || 'Nu am putut adăuga produsul. Încearcă din nou.');
      });
  });
})();

/**
 * Bara fixa de finalizare pe mobil (2026-08-24).
 *
 * De ce un observer si nu un eveniment: tema ToyTime nu emite nimic dupa ce modifica
 * cosul. cart.js inlocuieste innerHTML pe #main-cart-footer .js-content si pe
 * #main-cart-items .js-contents prin Section Rendering API, fara sa anunte pe nimeni.
 * Deci urmarim direct subtotalul randat de tema si il oglindim in bara.
 *
 * Bara sta ascunsa cat timp butonul real din sidebar e in viewport, ca sa nu apara
 * doua butoane identice unul peste altul.
 */
(function () {
  'use strict';

  var bara = document.querySelector('[data-br-sticky]');
  if (!bara) return;

  var suma = bara.querySelector('[data-br-sticky-suma]');
  var buton = bara.querySelector('[data-br-sticky-buton]');
  var sidebar = document.getElementById('main-cart-footer');

  var butonRealVizibil = false;
  var cosGol = false;

  function subtotalDinPagina() {
    var el = document.querySelector('#main-cart-footer .totals__subtotal-value');
    return el ? el.textContent.trim() : null;
  }

  function butonReal() {
    return document.querySelector('#main-cart-footer [name="checkout"]');
  }

  function actualizeaza() {
    var text = subtotalDinPagina();
    if (text && suma && text !== suma.textContent.trim()) suma.textContent = text;

    /* Semnalul curat de cos gol e chiar butonul temei: Liquid ii pune disabled
       cand cart == empty. Nu cauta .cart__empty-text, tema o randeaza mereu si o
       ascunde din CSS, deci ar da fals pozitiv pe orice cos plin. */
    var br = butonReal();
    cosGol = !br || br.disabled;
    if (buton) buton.disabled = cosGol;

    randeaza();
  }

  function randeaza() {
    var trebuieAratata = !cosGol && !butonRealVizibil;
    bara.hidden = cosGol;
    bara.classList.toggle('br-sticky--vizibil', trebuieAratata);
    document.body.classList.toggle('br-cos-cu-bara', trebuieAratata);
  }

  /* Cand butonul original intra in ecran, bara se retrage. */
  function urmaresteButonul() {
    var br = butonReal();
    if (!br || !('IntersectionObserver' in window)) {
      butonRealVizibil = false;
      randeaza();
      return;
    }
    if (urmaresteButonul._obs) urmaresteButonul._obs.disconnect();
    var obs = new IntersectionObserver(
      function (intrari) {
        butonRealVizibil = intrari[0].isIntersecting;
        randeaza();
      },
      { rootMargin: '0px 0px -24px 0px', threshold: 0.6 }
    );
    obs.observe(br);
    urmaresteButonul._obs = obs;
  }

  /* Sidebarul e reconstruit prin innerHTML, deci si nodul butonului se schimba.
     Observam parintele, nu copilul, altfel observerul moare la prima actualizare. */
  if (sidebar && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () {
      actualizeaza();
      urmaresteButonul();
    });
    mo.observe(sidebar, { childList: true, subtree: true, characterData: true });
  }

  actualizeaza();
  urmaresteButonul();
  window.addEventListener('pageshow', function () {
    actualizeaza();
    urmaresteButonul();
  });
})();
